import controllerDataConfigApi from '@/api/config/controllerDataConfig'
import { queryKeys } from '@/constant/common'
import { APIResponseList, SearchParams } from '@/types/common'
import { DecoderType } from '@/types/controller'
import { QueryOptions, useQuery, UseQueryResult } from '@tanstack/react-query'

function useSearchDecoderType(
  searchParams: SearchParams = {},
  queryOptions?: QueryOptions,
): UseQueryResult<APIResponseList<DecoderType>, any> {
  return useQuery(
    [queryKeys.controller, searchParams],
    async () => {
      const { data } = await controllerDataConfigApi.getDecoderType({
        ...searchParams,
      })

      if (!data) return null

      return {
        list: data.data,
        page: data.page,
        size: data.size,
        sort: data.sort,
        totalCount: data.totalCount,
        totalPage: data.totalPage,
      }
    },
    queryOptions,
  )
}

export default useSearchDecoderType
